/* @ngInject */
function authInterceptor ($location, $q, $state) {
  var interceptor = {
    responseError: function (res) {
      if (Number.parseInt(res.status) === 401) {
        if ($state.name.startsWith('guest')) {
          $location.path('/guest/login')
        } else {
          $location.path('/login')
        }
      }
      return $q.reject(res)
    }
  }
  return interceptor
}

export { authInterceptor }
